import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import BigNumber from 'bignumber.js';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';
import { CryptoService } from 'src/app/pages/core/abstraction/crypto.service';
import { GroupsService } from 'src/app/pages/core/abstraction/groups.service';
import { ICryptoPrice, ICryptoPrices } from 'src/app/pages/core/models/Crypto';
import { COIN_TYPE, IOrderStatus, OPERATION_TYPE } from 'src/app/pages/core/models/Order';
import { quoteCoins } from 'src/app/pages/core/models/group';
import { ConfirmSwapDialogComponent } from 'src/app/pages/core/pages/swap/confirm-swap-dialog/confirm-swap-dialog.component';
import { Utils } from 'src/app/pages/core/utils/Utils';
import { coins_pairs } from 'src/app/pages/core/utils/coins.constants';

@Component({
  selector: 'app-generic-swap',
  templateUrl: './generic-swap.component.html',
  styleUrls: ['./generic-swap.component.scss'],
})
export class GenericSwapComponent implements OnInit, OnChanges {
  @ViewChild('inputSearch', { static: false }) inputSearch: ElementRef;
  @Input() cryptoBalances: { [coin: string]: string } = {};
  @Input() cryptoPrices: ICryptoPrices = {};
  @Input() srcCoinSelectorOpened = false;
  @Input() destCoinSelectorOpened = false;
  @Input() availableCoins: string[] = [];
  @Input() isGroup: boolean = false;
  @Input() coinClicked: string;
  @Output() openSelectSrcCoin: EventEmitter<boolean> = new EventEmitter();
  @Output() openSelectDestCoin: EventEmitter<boolean> = new EventEmitter();
  srcCoin = 'USDT';
  destCoin = 'ETH';
  currentCoinPair = 'ETH_USDT';
  currentPrice: ICryptoPrice;
  srcValueControl: FormControl = new FormControl('', [Validators.required]);
  destValueControl: FormControl = new FormControl('', [Validators.required]);
  isProcessing = false;
  ordersStatus: IOrderStatus;
  filteredArray = [];
  searchValue: FormControl = new FormControl('');
  page: number = 0;
  limit: number = 16;
  totalPages: number;
  updatePages: number;
  pageNumber: number = 1;
  current: number = 0;
  auxAvailableCoins;
  coins_pairs = coins_pairs;
  quoteCoins = quoteCoins;
  isMobile: boolean;
  // TODO: Quitar dependencia de cryptoservice para que sea abstracto.
  constructor(
    private dialog: MatDialog,
    public cryptoService: CryptoService,
    private authService: AuthService,
    private groupsService: GroupsService,
  ) {}

  ngOnInit(): void {
    this.auxAvailableCoins = this.availableCoins;
    this.authService.sendTikTokPageView(window.location.href).subscribe();
    if (this.isGroup) {
      this.filteredArray = this.availableCoins;
      if (this.coinClicked) {
        this.srcCoin = this.coinClicked;
        if (quoteCoins[this.srcCoin] && this.srcCoin !== 'BTC' && this.srcCoin !== 'ETH') {
          this.destCoin = 'BTC';
          this.currentCoinPair = this.destCoin + '_' + this.srcCoin;
        } else {
          this.destCoin = 'USDT';
          this.currentCoinPair = this.srcCoin + '_' + this.destCoin;
        }
        this.setMaxSrcCoinBalance();
      }
      this.getTotalPages();
      this.getPriceGroup(this.currentCoinPair.split('_').join(''));
    }
    if (this.srcValueControl.value !== '' && this.destValueControl.value !== '') {
      this.syncAmount(COIN_TYPE.DEST_COIN);
    }
    this.isMobile = Utils.onMobile();
    if (this.isMobile) this.limit = 15;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cryptoPrices) this.currentPrice = this.cryptoPrices[this.currentCoinPair];
  }

  openCoinSelector(type: number) {
    if (type === COIN_TYPE.SRC_COIN) {
      this.srcCoinSelectorOpened = !this.srcCoinSelectorOpened;
      this.destCoinSelectorOpened = false;
      this.openSelectSrcCoin.emit(this.srcCoinSelectorOpened);
      if (this.isGroup) {
        this.availableCoins = this.auxAvailableCoins;
        this.filteredArray = this.auxAvailableCoins;
      }
    } else {
      this.destCoinSelectorOpened = !this.destCoinSelectorOpened;
      this.srcCoinSelectorOpened = false;
      this.openSelectDestCoin.emit(this.destCoinSelectorOpened);
      if (this.isGroup) this.filterDestCoin();
    }
    if (this.isGroup) {
      this.setDefaultValues();
      setTimeout(() => {
        this.inputSearch.nativeElement.focus();
      }, 0);
    }
  }

  selectCoin(type: number, coin: string) {
    if (coin) {
      if (
        (type === COIN_TYPE.SRC_COIN && coin !== this.destCoin) ||
        (type === COIN_TYPE.DEST_COIN && coin !== this.srcCoin)
      ) {
        if (type === COIN_TYPE.SRC_COIN) {
          this.srcCoin = coin;
          this.currentCoinPair = this.srcCoin + this.destCoin;
        } else {
          this.destCoin = coin;
        }
        if (this.isGroup) {
          let coin;
          if (quoteCoins[this.srcCoin] && this.srcCoin !== 'BTC' && this.srcCoin !== 'ETH') {
            this.currentCoinPair = this.destCoin + this.srcCoin;
            coin = this.destCoin;
          } else {
            this.currentCoinPair = this.srcCoin + this.destCoin;
            coin = this.srcCoin;
            if (this.srcCoin === 'BTC' || this.srcCoin === 'ETH') {
              if (quoteCoins[this.destCoin] && this.destCoin !== 'ETH') {
                this.currentCoinPair = this.srcCoin + this.destCoin;
                coin = this.srcCoin;
              } else {
                this.currentCoinPair = this.destCoin + this.srcCoin;
                coin = this.destCoin;
              }
            }
          }
          this.getPriceGroup(this.currentCoinPair, coin);
          this.currentCoinPair = this.currentCoinPair.replace(coin, coin + '_');
        } else {
          this.currentCoinPair = this.cryptoService.getValidSwapPair(this.srcCoin, this.destCoin);
          if (this.currentCoinPair === '') {
            if (this.srcCoin === 'USDC') {
              this.destCoin = 'USDT';
            } else {
              this.destCoin = 'DAI';
            }
            this.currentCoinPair = this.cryptoService.getValidSwapPair(this.srcCoin, this.destCoin);
          }
          this.currentPrice = this.cryptoPrices[this.currentCoinPair];
          this.syncAmount(COIN_TYPE.DEST_COIN);
        }
      } else {
        this.switchCoins();
      }
    }
    if (type === COIN_TYPE.SRC_COIN) {
      this.srcCoinSelectorOpened = false;
    } else {
      this.destCoinSelectorOpened = false;
    }
  }

  swapBtnClicked() {
    this.isProcessing = true;
    let operation;
    if (this.isGroup) {
      if (quoteCoins[this.srcCoin] && this.srcCoin !== 'BTC' && this.srcCoin !== 'ETH')
        operation = 'BUY';
      else {
        if (this.srcCoin === 'BTC' || this.srcCoin === 'ETH') {
          if (quoteCoins[this.destCoin] && this.destCoin !== 'ETH') {
            operation = 'SELL';
          } else {
            operation = 'BUY';
          }
        } else operation = 'SELL';
      }
    } else {
      operation = this.cryptoService.isBuyingSwapPair(this.srcCoin, this.destCoin) ? 'BUY' : 'SELL';
    }
    this.dialog
      .open(ConfirmSwapDialogComponent, {
        panelClass: 'modal-container',
        backdropClass: 'dialog-primary-backdrop',
        maxWidth: '90vw',
        width: '500px',
        data: {
          srcCoin: this.srcCoin,
          destCoin: this.destCoin,
          srcCoinAmount: (this.srcValueControl.value as string).replace(',', '.'),
          destCoinAmount: (this.destValueControl.value as string).replace(',', '.'),
          currentCoinPair: this.currentCoinPair,
          operation,
          price: operation === OPERATION_TYPE.BUY ? this.currentPrice.buy : this.currentPrice.sell,
          title: this.isGroup ? 'Confirmar operación' : 'Intercambio de monedas',
          isGroup: this.isGroup,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.srcValueControl.setValue('');
          this.destValueControl.setValue('');
          if (this.isGroup) {
            this.getPriceGroup(this.currentCoinPair.split('_').join(''));
          }
        }
        this.isProcessing = false;
      });
  }

  checkSwapAvailable() {
    const srcValue = new BigNumber((this.srcValueControl.value as string).replace(',', '.'));
    if (
      !this.srcValueControl.valid ||
      !this.destValueControl.valid ||
      !this.cryptoBalances[this.srcCoin] ||
      srcValue.isGreaterThan(new BigNumber(this.cryptoBalances[this.srcCoin])) ||
      srcValue.isEqualTo(0) ||
      srcValue.isLessThan(new BigNumber('0.00001')) ||
      this.destCoin === 'UST' ||
      this.destCoin === 'LUNA' ||
      this.srcCoin === 'UST' ||
      this.srcCoin === 'LUNA' ||
      this.destCoin === 'USTC' ||
      this.destCoin === 'LUNC' ||
      this.srcCoin === 'USTC' ||
      this.srcCoin === 'LUNC' ||
      this.ordersStatus?.BUY?.coins.some((status) => status === this.currentCoinPair) ||
      this.ordersStatus?.SELL?.coins.some((status) => status === this.currentCoinPair)
    ) {
      return false;
    }
    return true;
  }

  getButtonText() {
    const srcValue: string = (this.srcValueControl.value as string)
      ? (this.srcValueControl.value as string).replace(',', '.')
      : '';

    if (
      this.srcValueControl.value === '' ||
      this.destValueControl.value === '' ||
      parseFloat(srcValue) === 0
    ) {
      return 'Ingresá un valor';
    } else if (
      !this.cryptoBalances[this.srcCoin] ||
      parseFloat(srcValue) > parseFloat(this.cryptoBalances[this.srcCoin])
    ) {
      return `${this.srcCoin} insuficiente`;
    } else if (
      this.destCoin === 'USTC' ||
      this.destCoin === 'LUNC' ||
      this.srcCoin === 'USTC' ||
      this.srcCoin === 'LUNC'
    ) {
      return 'No disponible';
    } else {
      return this.isGroup ? 'Previsualizar conversión' : 'Cambiar';
    }
  }

  setMaxSrcCoinBalance() {
    const cryptoBalance: string = this.cryptoBalances[this.srcCoin] || '0';

    if (
      cryptoBalance === '0' ||
      (this.cryptoService.isStableCoin(this.srcCoin) && new BigNumber(cryptoBalance).isLessThan(1))
    ) {
      return;
    }
    this.srcValueControl.setValue(cryptoBalance.replace('.', ','));
    this.syncAmount(COIN_TYPE.DEST_COIN);
  }

  switchCoins() {
    let auxCoin = this.srcCoin;
    this.srcCoin = this.destCoin;
    this.destCoin = auxCoin;
    let auxValue: string = this.srcValueControl.value;
    this.srcValueControl.setValue((this.destValueControl.value as string).replace('.', ','));
    this.destValueControl.setValue(auxValue.replace('.', ','));
    if (this.isGroup) {
      this.filterDestCoin();
      if (!this.availableCoins.includes(this.destCoin)) {
        this.srcCoin !== 'USDT' ? (this.destCoin = 'USDT') : (this.destCoin = 'USDC');
      }
    }
  }

  syncAmount(type: number) {
    if (type === COIN_TYPE.SRC_COIN) {
      if (!this.destValueControl.value || this.destValueControl.value === '0') {
        this.srcValueControl.setValue('0');
        return;
      }
      let srcValue: BigNumber;
      const destValue = new BigNumber((this.destValueControl.value as string).replace(',', '.'));

      if (this.currentCoinPair.split('_')[0] === this.destCoin) {
        srcValue = destValue.multipliedBy(new BigNumber(this.currentPrice?.buy));
      } else {
        srcValue = destValue.dividedBy(new BigNumber(this.currentPrice?.sell));
      }

      this.srcValueControl.setValue(srcValue.toFixed().replace('.', ','));
    } else if (COIN_TYPE.DEST_COIN) {
      if (!this.srcValueControl.value || this.srcValueControl.value === '0') {
        this.destValueControl.setValue('0');
        return;
      }
      let destValue: BigNumber;
      const srcValue = new BigNumber((this.srcValueControl.value as string).replace(',', '.'));
      if (this.currentCoinPair.split('_')[0] === this.destCoin) {
        destValue = srcValue.dividedBy(new BigNumber(this.currentPrice?.buy));
      } else {
        destValue = srcValue.multipliedBy(new BigNumber(this.currentPrice?.sell));
      }
      this.destValueControl.setValue(destValue.toFixed().replace('.', ','));
    }
  }

  search() {
    this.page = 0;
    this.current = 0;
    this.pageNumber = 1;
    this.availableCoins = this.filteredArray.filter((item) => {
      return item.toLowerCase().includes(this.searchValue.value.toLowerCase());
    });
    this.getTotalPages();
  }

  filterDestCoin() {
    let coinsAvailable = [];
    Object.values(coins_pairs).map((coin) => {
      if (quoteCoins[this.srcCoin] && this.srcCoin !== 'BTC' && this.srcCoin !== 'ETH') {
        if (coin.coin === coin.baseCoin + this.srcCoin) {
          coinsAvailable.push(coin.baseCoin);
        }
      } else {
        if (coin.coin === this.srcCoin + quoteCoins[coin.quoteCoin])
          coinsAvailable.push(coin.quoteCoin);
        else {
          if (
            (this.srcCoin === 'BTC' || this.srcCoin === 'ETH') &&
            coin.coin === coin.baseCoin + this.srcCoin &&
            coin.baseCoin !== 'TUSD'
          ) {
            coinsAvailable.push(coin.baseCoin);
          }
        }
      }
    });
    this.availableCoins = coinsAvailable;
    this.filteredArray = coinsAvailable;
  }

  nextPage() {
    if (this.page + 1 < this.totalPages) {
      if (this.current === 2 && this.pageNumber + 2 < this.totalPages) {
        this.current = 0;
        this.pageNumber += 2;
        if (this.pageNumber + 2 > this.totalPages) {
          this.pageNumber = this.totalPages - 2;
          this.current = 1;
        }
      }
      this.page += 1;
      this.current += 1;
    }
  }

  prevPage() {
    if (this.page > 0) {
      if (this.current === 0 && this.pageNumber > 1) {
        this.current = 2;
        this.pageNumber -= 2;
        if (this.pageNumber === 0) {
          this.pageNumber = 1;
          this.current = 1;
        }
      }
      this.page -= 1;
      this.current -= 1;
    }
  }

  changePage(page: number) {
    this.page = page;
  }

  getTotalPages() {
    this.totalPages = this.availableCoins.length / this.limit;
    if (this.totalPages > Math.round(this.totalPages))
      this.totalPages = Math.round(this.totalPages) + 1;
    else this.totalPages = Math.round(this.totalPages);
    if (this.totalPages >= 3) this.updatePages = 3;
    else {
      if (this.totalPages < 3 && this.totalPages > 1) this.updatePages = 2;
      else this.updatePages = 1;
    }
  }

  setDefaultValues() {
    this.searchValue.setValue('');
    this.page = 0;
    this.pageNumber = 1;
    this.current = 0;
    this.getTotalPages();
  }

  checkPage(pageNumber: number, index: number) {
    this.page = pageNumber - 1;
    this.current = index;
  }

  getPriceGroup(coinPair, coin?) {
    if (!coins_pairs[coinPair] && this.destCoin !== 'BTC' && this.destCoin !== 'ETH') {
      coinPair = coin + 'USDT';
      this.currentCoinPair = coinPair;
      this.destCoin = 'USDT';
    } else {
      if ((this.destCoin === 'BTC' || this.destCoin === 'ETH') && !coins_pairs[coinPair]) {
        coinPair = coin + 'USDT';
        this.currentCoinPair = coinPair;
        this.destCoin = 'USDT';
      }
    }
    this.groupsService.getPriceGroup(coinPair).subscribe((resp) => {
      this.currentPrice = {
        coin: resp.symbol,
        buy: resp.price.buy,
        sell: resp.price.sell,
      };
      this.syncAmount(COIN_TYPE.DEST_COIN);
    });
  }
}
